import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheck, Clock, FileText } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-navy text-white pt-12 pb-16 md:pt-20 md:pb-24 overflow-hidden" data-id="element-99">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-gold via-transparent to-transparent" data-id="element-100"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center text-center space-y-6 md:space-y-8" data-id="element-102">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight max-w-3xl" data-id="element-103">
            Todo lo que necesitás para que tu{' '}
            <span className="text-brand-gold" data-id="element-104">consultorio funcione</span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-[70%] mx-auto" data-id="element-105">
            <div className="absolute -inset-4 bg-brand-gold/20 rounded-full blur-3xl" data-id="element-106"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3kwV8246M1qMzdJnM5cJHS/Mockup_dermatologia_transparente.png" alt="Sistema de protocolos para el consultorio dermatológico" width={900} height={900} fetchPriority="high" decoding="async" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-107" />
          </motion.div>

          <p className="text-lg md:text-xl text-slate-300 font-light leading-relaxed max-w-2xl" data-id="element-108">
            Un método clínico y operativo, listo para aplicar desde tu próxima
            consulta: cronogramas de adherencia, protocolos de alarma
            post-procedimiento, comunicación estandarizada y resguardo legal.{' '}
            <strong className="text-white font-semibold" data-id="element-109">
              Sin improvisar más entre consultas.
            </strong>
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-2 md:pt-4" data-id="element-110">
            <Button href="#pricing" className="text-lg md:text-xl py-4 px-6 md:py-5 md:px-10 w-full sm:w-auto" data-id="element-111">
              💥 QUIERO MI PROTOCOLO AHORA
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 pt-6 md:pt-8 border-t border-brand-blue w-full max-w-3xl" data-id="element-112">
            <div className="flex items-center justify-center gap-3 text-sm text-slate-300 text-left" data-id="element-113">
              <FileText className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-114" />
              <span data-id="element-115">
                PDF Digital
                <br data-id="element-116" />
                Acceso Inmediato
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 text-sm text-slate-300 text-left" data-id="element-117">
              <ShieldCheck className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-118" />
              <span data-id="element-119">
                Garantía 7 días
                <br data-id="element-120" />
                Descargá y Aplicá
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 text-sm text-slate-300 text-left" data-id="element-121">
              <Clock className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-122" />
              <span data-id="element-123">
                Sin Software ni
                <br data-id="element-124" />
                Curva de Aprendizaje
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}